import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { AppSidebar } from "@/blocks/AppSidebar";
import { SidebarProvider } from "@/context/SidebarProvider";

export const AdminLayout = () => {
  return (
    <SidebarProvider>
      <AppSidebar />
      <Outlet />
    </SidebarProvider>
  );
};

export const Route = createFileRoute("/_authed/admin")({
  component: AdminLayout,
  beforeLoad: ({ context }) => {
    if (
      (context.userType && context.userType === "STUDENT") ||
      (context.userRole && context.userRole === "INSTRUCTOR")
    ) {
      throw redirect({
        to: "/",
        search: {
          redirect: location.href.includes("/logout")
            ? undefined
            : location.href,
        },
      });
    }
  },
});
